import { Card, CardContent } from '../../../components/ui';

export default function EmptyState() {
    return (
        <Card>
            <CardContent className="py-16">
                <div className="text-center max-w-md mx-auto">
                    <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#f59e0b] to-[#fbbf24] flex items-center justify-center mx-auto mb-4">
                        <svg
                            className="w-8 h-8 text-white"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                            />
                        </svg>
                    </div>
                    <h3 className="text-xl font-semibold text-[#1e293b] mb-2">
                        Select a Store Brand
                    </h3>
                    <p className="text-[#64748b]">
                        Search and select a store brand above to view and manage store live statuses
                    </p>
                </div>
            </CardContent>
        </Card>
    );
}
